<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <img alt="g-modal-image" *ngIf="true" src="./assets/icons/ic_alert.svg" class="dhl-dialog-img" />
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2"></div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row text-center">
    <div class="col" [innerHTML]="dialogData.message"></div>
  </div>
  <div class="row text-center">
    <div class="col">
      <br />
      <p>* Para mayor información consulta <span class="text-decoration-underline cursor-pointer" color="red" (click)="redirectToTerms()">términos y condiciones</span></p>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button
    *ngIf="dialogData.showCancel"
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    class="dhl-btn-secundary"
    [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button *ngIf="dialogData.showAccept" mat-flat-button cdkFocusInitial color="accent" (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>
